const DV7_ACCESS_COMPANY_IDS = [3685, 3801, 2300, 2774, 669, 1059, 1053];
const DV7_ACCESS_PARTNERS = ['DV7 Rosco Testing'];
const isProd = window.location.hostname === 'fleet.roscolive.com';
const isDV7Listed = ({ company_id, partner } = {}) => DV7_ACCESS_PARTNERS.includes(partner) || DV7_ACCESS_COMPANY_IDS.includes(company_id);
export const getDV7Access = (user) => !isProd || isDV7Listed(user);
export const getCustomDV7Access = (user) => isProd && isDV7Listed(user);